import { setMode } from '@stencil/core';
import { isMagnoliaEditingMode } from '../helper';

export default async () => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */

  // Set the mode to 'editing' if the URL parameter 'authorEditMode' is present
  // This is necessary for the archiving process in Magnolia
  window.ui = window.ui || ({} as any);
  window.ui.cmsState = window.ui.cmsState || ({} as any);
  if (!window.ui.cmsState.mode) {
    window.ui.cmsState.mode = new URL(window.location.href).searchParams.has('authorEditMode') ? 'editing' : '';
  }

  setMode(() => (isMagnoliaEditingMode() ? 'editing' : 'default'));
};
